var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Contact'),_c('br'),_c('br'),_c('br'),_c('br'),(_vm.contactList != '')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }